import { useState } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useRouter } from "next/router";
import apiService from "../pages/api/apiService";
import { generateAuthToken } from "../pages/api/utils";
import { setAuth } from "../store/authSlice";
import styles from "../styles/SupporterModal.module.css";

export default function AuthPopup({ email, onClose, reset }) {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const dispatch = useDispatch();
    const router = useRouter();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        if (!password || !confirmPassword) {
            setError("Both fields are required");
            return;
        }

        if (password !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }

        try {
            const authTokenGen = generateAuthToken(email + "RESET");

            const response = await apiService.post("/reset_password", {
                email,
                password,
                confirmPassword,
                auth_token: authTokenGen,
                action: reset ? "reset" : "create",
            });

            if (response.success) {
                toast.success(response.message || (reset ? "Password reset successful" : "Password created"), { autoClose: 3000 });

                dispatch(
                    setAuth({
                        authToken: response.user_details.auth_token,
                        userId: response.user_details.id,
                        profile_picture: response.user_details.profile_picture,
                        name: response.user_details.name,
                        stripeId: response.user_details.stripe_customer_id,
                        email: response.user_details.email,
                    })
                );

                setPassword("");
                setConfirmPassword("");
                onClose();

                setTimeout(() => {
                    if (response?.last_url) router.push(response.last_url);
                    else router.push("/dashboard");
                }, 1000);
            } else {
                throw new Error(response.message || "Operation failed");
            }
        } catch (err) {
            toast.error("Something went wrong. Please try again.", { autoClose: 3000 });
        }
    };

    return (
        <div className={`${styles.overlay} d-flex justify-content-center align-items-center`}>
            <div className={styles.bgCircle}></div>
            <div className={`${styles.card} border-0 rounded-4 p-4 position-relative`}>
                <button onClick={onClose} className={`${styles.closeIcon}`} style={{ width: "32px", height: "32px" }}>✕</button>

                <div className="text-center mb-3">
                    <h3 className="login-heading mb-3">{reset == "true" ? "Reset Password" : "Create Password"}</h3>
                    <p className="paragraph-2">
                        {reset == "true"
                            ? "Enter your new password and confirm it to reset your password."
                            : "Enter your password details to create a new password."}
                    </p>
                </div>

                <div className="mb-3 text-start position-relative">
                    <input
                        type={showPassword ? "text" : "password"}
                        className="input w-input form-control"
                        placeholder="Password*"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <span
                        className="material-symbols-outlined"
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            userSelect: "none",
                            fontSize: "20px",
                            color: "#555",
                        }}
                    >
                        {showPassword ? "visibility" : "visibility_off"}
                    </span>

                </div>

                <div className="mb-3 text-start position-relative">
                    <input
                        type={showConfirmPassword ? "text" : "password"}
                        className="input w-input form-control"
                        placeholder="Confirm Password*"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    <span
                        className="material-symbols-outlined"
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            userSelect: "none",
                            fontSize: "20px",
                            color: "#555",
                        }}
                    >
                        {showConfirmPassword ? "visibility" : "visibility_off"}
                    </span>

                </div>

                {error && <small className="text-danger d-block mb-2">{error}</small>}

                <button
                    onClick={handleSubmit}
                    className="cta-btn w-100 d-flex justify-content-center"
                >
                    {reset == "true" ? "Update Password" : "Create Password"}
                </button>
            </div>
        </div>
    );
}
